export const USA_PCB_ASSEMBLY_ID = 657;
export const MX_PCB_ASSEMBLY_ID = 1549;